export const product = {
  product: "Product",
  allProducts: "Products & Services",
  myProducts: "My Products",
  assetManagement: "My Assets",
  addProduct: "Add Product",
  addEditProduct: "Add/Edit Product",
  saveProduct: "Save Product",
  productProperties: "Product Properties",
  productAttributes: "Product Attributes",
  additionalAttributes: "Additional Properties",
  additionalAttributesHelp:
    "These fields come from the current Back Office additional properties schema.",
  additionalAttributesSaved: "Additional properties saved.",
  additionalAttributesEmpty:
    "No additional properties have been saved for this product.",
  additionalAttributesNoSchema:
    "No additional properties schema has been uploaded yet.",
  additionalAttributesLoadError:
    "Could not load the additional properties schema.",
  dppRegistryAddError:
    "Could not register the digital product passport. The product was still saved.",
  dppRegistryVerifyError:
    "Could not verify the digital product passport. The product was still saved.",
  dppRegistryVerifyMismatches:
    "Passport verification found tampered fields. Open the DPP tab to review them.",
  dppSourceUrlLabel: "DPP endpoint",
  dppSourceUrlHint:
    "Optional GET URL. On save, its JSON replaces the editor below. Leave empty to keep what is already in the editor. An http address is loaded by this marketplace. An https address is loaded by your browser.",
  dppSourceUrlInvalid: "Enter an http or https URL.",
  dppSourceUrlNetworkError:
    "Could not load the digital product passport from that URL. Check the address. For an https URL, the server must also allow this site to read it.",
  dppSourceUrlNotJson: "The URL did not return JSON.",
  dppSourceUrlNotPassport:
    "The JSON from that URL is not a digital product passport.",
  additionalAttributesNumberInvalid: "Enter a valid number.",
  additionalAttributesPatternInvalid:
    "Value does not match the configured validation pattern.",
  listingTypeProduct: "Product",
  remanufacturingServiceBadge: "Remanufacturing Service",
  productClass: "Product class",
  productClassHelp:
    "Choose the product type class to show matching additional properties. Leave unset to edit only universal properties.",
  productClassNotSet: "Not set",
  allProductClasses: "All classes",
  additionalAttributesEmptyForClass:
    "No additional properties apply to the selected product class.",
  parameterGroup_energy: "Energy",
  additionalAttributeGroupSection: "Property group",
  additionalAttributeGroupSelectPlaceholder: "Select a property group…",
  productEditStepBasic: "Basic information",
  productEditStepClass: "Product class",
  productEditStepGroup: "Property group",
  productEditStepLockedHint: "Save the previous step to continue.",
  confirmUnsavedTitle: "Discard unsaved changes?",
  confirmChangeSelection:
    "You have unsaved changes on this step. If you continue, those changes will be lost.",
  discardAndContinue: "Discard and continue",
  productCategories: "Product Categories",
  propertyValue: "Property Value",
  publicName: "Public Name",
  name: "Name",
  tradeName: "Trade Name",
  vat: "VAT",
  url: "URL",
  productName: "Product Name",
  description: "Description",
  cost: "Cost",
  numerical: "Numerical",
  products: "Products",
  productDetails: "Product Details",
  productDetailsNavigation: "Product page sections",
  productPassportTab: "DPP",
  productPassportIntro:
    "Verified digital product passport for this asset, including identity, performance, and sustainability data.",
  productPassportTabDisabledPendingAcceptance:
    "Available after the provider accepts your express of interest.",
  productPassportTabDisabledSignIn:
    "Sign in and express interest to access the Digital Product Passport after acceptance.",
  productPassportTabDisabledLoading:
    "Checking your express of interest status…",
  productInterestSentSuccess:
    "Interest sent. You can track updates in My Requests.",
  productInterestAlreadyOpen:
    "You already have an active expression of interest for this product. Track it in My Requests.",
  productInterestDuplicateError:
    "You already have an expression of interest for this product.",
  productInterestOpenBadge: "Interest submitted",
  productInterestOpenBanner:
    "You already expressed interest in this product. Current status: {{status}}.",
  productInterestViewRequests: "View in My Requests",
  manufacturer: "Manufacturer",
  yearOfManufacturing: "Year of Manufacturing",
  uponRequest: "Upon Request",
  priceUponRequest: "Price Upon Request",
  noProducts: "No products",
  productManagerNewBadge: "New",
  productManagerEmptyHint:
    "Add a product or adjust your filters to see your listings here.",
  productManagerFiltersHint:
    "Narrow your catalog by name, tags, or price range.",
  productManagerAdvancedFiltersHint:
    "Refine results with tags or a price range.",
  priceRangeAny: "Any price",
  filterByName: "Filter by name",
  filterByAuthor: "Filter by author",
  sortBy: "Sort by",
  sortOrder: "Sort order",
  sortAscending: "Ascending",
  sortDescending: "Descending",
  productsBrowseEmptyHint:
    "Try adjusting your search or filters to find products listed for sale.",
  minPrice: "Min price",
  maxPrice: "Max price",
  postedBy: "Posted By",
  createdAt: "Created At",
  selectSubCategory: "Select Sub-Category",
  selectExtraCategory: "Select Extra Category",
  price: "Price",
  isUsed: "Is Used",
  condition: "Condition",
  contactPerson: "Contact Person",
  person: "Person",
  contactEmail: "Contact Email",
  email: "Email",
  contactPhoneNumber: "Contact Phone Number",
  phoneNumber: "Phone Number",
  paymentInfo: "Payment Info",
  updateProduct: "Update Product",
  updatedAt: "Updated At",
  inventory: "Inventory",
  quantity: "Quantity",
  addInventory: "Add Inventory",
  notes: "Notes",
  myProduct: "My Product",
  addToCart: "Add to Cart",
  createdBy: "From",
  me: "Me",
  filters: "Filters",
  filter: "Filter",
  clear: "Clear",
  details: "Details",
  withImages: "With Images",
  author: "Author",
  syncWithExternalMarketplaces: "Sync with External Marketplaces",
  somethingWentWrong: "Something went wrong",
  pleaseContactTheAdministrator: "Please contact the administrator",
  perPage: "per page",
  fillThePropertyFirst: "Fill the property first",
  onlyDeletesEmptyProperty: "Only deletes empty property",
  basicInformation: "Basic Information",
  secondaryInformation: "Secondary Information",
  generalOrderInfo: "General Order Info",
  linePerformance: "Production line & Performance",
  all: "All",
  forSale: "For Sale",
  currentOwner: "Current Owner",
  serialNumber: "Serial Number",
  installationRequirements: "Installation Requirements",
  processingInfo: "Processing Info",
  notForSale: "Not For Sale",
  spareParts: "Spare Parts",
  incumbent: "Incumbent",
  productCapabilities: "Product Capabilities",
  equipmentCapabilities: "Equipment Capabilities",
  deleteProduct: "Delete Product",
  deleteProductWarning: "Are you sure you want to delete this product?",
  anErrorOccurred: "An error occurred",
  errorFetchingProducts: "Error fetching products",
  lastRemanufacturer: "Last Re-Manufacturer",
  yearOfLastRemanufacturing: "Year of Last Re-Manufacturing",
  tags: "Tags",
  tag: "Tag",
  deleteThisProduct: "Delete this product",
  requiredWorkerSkills: "Required Worker Skills",
  existingWorkerSkills: "Existing Worker Skills",
  workerSkills: "Worker Skills",
  factoryOwnerRequirements: "Factory Owner Requirements",
  environmentalProperties: "Environmental Properties",
  connectionCapabilities: "Connection Capabilities",
  byAuction: "By Auction",
  visitWebsite: "Visit Website",
  manufacturedYear: "Manufactured Year",
  productId: "Product ID",
  productIdPending: "Assigned automatically when saved",
  ownerKeycloak: "Owner (Keycloak user ID)",
  owner: "Owner",
  ownerFieldTooltip: "State the current owner",
  videoAssets: "Video",
  documentAssets: "Documents",
  basePrice: "Base price",
  promotionalPrice: "Promotional price",
  taxRate: "Tax rate",
  currency: "Currency",
  availableQuantity: "Available quantity",
  clickOrDropMediaFiles:
    "Click or drag files here to upload video or document assets.",
  clickOrDropImageFiles: "Click or drag files here to upload images.",
  clickOrDropVideoFiles: "Click or drag files here to upload videos.",
  clickOrDropDocumentFiles: "Click or drag files here to upload documents.",
  dataset: "Dataset",
  datasets: "Datasets",
  datasetManagement: "Dataset Management",
  allDatasets: "All Datasets",
  myDatasets: "My Datasets",
  noDatasets: "No datasets",
  datasetName: "Dataset Name",
  dataType: "Data Type",
  industrySector: "Industry Sector",
  format: "Format",
  datasetDetails: "Dataset Details",
  dataCollectionMethod: "Data Collection Method",
  associatedResearch: "Associated Research",
  systemicInnovation: "Systemic Innovation",
  systemicInnovations: "Systemic Innovations",
  associatedSystemicInnovations: "Associated Systemic Innovations",
  mySystemicInnovations: "My Systemic Innovations",
  allSystemicInnovations: "All Systemic Innovations",
  addSystemicInnovation: "Add Systemic Innovation",
  implementationLevel: "Implementation Level",
  licenseType: "License Type",
  benefits: "Benefits",
  addEditDataset: "Add/Edit Dataset",
  addEditSystemicInnovation: "Add/Edit Systemic Innovation",
  systemicInnovationDetails: "Systemic Innovation Details",
  regulatoryCompliance: "Regulatory Compliance",
  competitionAnalysis: "Competition Analysis",
  valueProposition: "Value Proposition",
  problemStatement: "Problem Statement",
  deleteDataset: "Delete Dataset",
  contactPhone: "Contact Phone",
  shortDescription: "Short Description",
  fullDescription: "Full Description",
  dataProvider: "Data Provider",
  size: "Size",
  updateFrequency: "Update Frequency",
  accessLevel: "Access Level",
  geographicalScope: "Geographical Scope",
  timePeriodCovered: "Time Period Covered",
  variablesFeatures: "Variables & Features",
  compliancePlusStandards: "Compliance & Standards",
  associatedResearchPublications: "Associated Research & Publications",
  pricingInfo: "Pricing Information",
  contactPersonOrganization: "Contact Person / Organization",
  lastUpdated: "Last Updated",
  insertedByUser: "Inserted by User",
  apiUrl: "API URL",
  leadingOrganizations: "Leading Organizations",
  technologyStack: "Technology Stack",
  objectives: "Objectives",
  benefitsAndExpectedOutcomes: "Benefits & Expected Outcomes",
  measurableImpact: "Measurable Impact",
  pilotLocations: "Pilot Locations",
  caseStudies: "Case Studies",
  regulatoryComplianceAndEthicsConsiderations:
    "Regulatory Compliance & Ethics Considerations",
  publicationsReportsAndMedia: "Publications, Reports & Media",
  relatedDatasets: "Related Datasets",
  pricingModel: "Pricing Model",
  noSystemicInnovations: "No Systemic Innovations",
  addDataset: "Add Dataset",
  informationAboutBusinessModels: "Information about Business Models",
  businessModels: "Business Models",
  processingAndInstallation: "Processing & Installation",
  basePlateWidth: "Base Plate Width",
  basePlateLength: "Base Plate Length",
  basePlateMountingInfo: "Base Plate Mounting Info",
  mountingPosition: "Mounting Position",
  foundationRequirements: "Foundation Requirements",
  ambientTempMin: "Ambient Temp Min",
  ambientTempMax: "Ambient Temp Max",
  pressureAirSupply: "Pressure Air Supply",
  pressureAirSpecs: "Pressure Air Specs",
  exhaustSystem: "Exhaust System",
  exhaustSystemSpecs: "Exhaust System Specs",
  powerConnection: "Power Connection",
  powerConnectionSpecs: "Power Connection Specs",
  waterSupply: "Water Supply",
  waterSupplySpecs: "Water Supply Specs",
  gasSupply: "Gas Supply",
  gasSupplySpecs: "Gas Supply Specs",
  energyConsumption: "Energy Consumption",
};
